































































































import { Component, Mixins } from "vue-property-decorator";

import ButtonsMixin from "@/mixins/Buttons.mixin";

@Component
export default class BaseButton extends Mixins(ButtonsMixin) {
  private focused = false;
}
